module.exports = __webpack_public_path__ + "security-testing.18uGKHbl.svg";